import { getApiOrigin } from '@/config/env';
import { getToken } from '@/utils/auth';

export type AmbassadorConversionRow = {
  staffId: string;
  name: string;
  memberCode: string | null;
  staffCode: string | null;
  qrScans: number;
  completedSurveys: number;
  conversionRatePct: number;
};

export type QrTrackingSummary = {
  totalQrScans: number;
  totalCompletedSurveys: number;
  surveyCompletionRate: number;
};

export type QrTrackingData = {
  summary: QrTrackingSummary;
  ambassadors: AmbassadorConversionRow[];
};

export async function fetchQrTracking(input: {
  startISO: string;
  endISO: string;
}): Promise<QrTrackingData> {
  const apiUrl = getApiOrigin();
  const params = new URLSearchParams({
    startDate: input.startISO,
    endDate: input.endISO,
  });

  const res = await fetch(`${apiUrl}/api/v1/admin/qr-tracking?${params.toString()}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

  const body = (await res.json().catch(() => ({}))) as {
    ok?: boolean;
    data?: QrTrackingData;
    error?: string;
  };

  if (!res.ok || !body.ok || !body.data) {
    throw new Error(body.error || `Failed to load QR tracking (HTTP ${res.status})`);
  }

  return body.data;
}
